<div class="card dialog-box cp-dialogue-width">
  <div class="card-header">
    Select Checkpoints
    <!-- @if (cpSiteFilter?.id) {
      for
      <span class="fw-semibold">
        {{ cpSiteFilter?.company_name }}
        @if (cpSiteFilter?.company?.company_name) {
          <span> [{{ cpSiteFilter?.company?.company_name }}] </span>
        }
      </span>
    } -->
    <span class="float-end" (click)="onDialogClose()">
      <i class="fa-solid fa-xmark"></i>
    </span>
  </div>

  @if (!largeView) {
    <div class="row row-cols-2 mb-3">
      <div class="col">
        <button class="btn btn-lg btn-dark w-100" (click)="onDialogClose()">
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          type="submit"
          class="btn btn-lg btn-primary w-100"
          (click)="onDialogClose(true)"
        >
          Save
        </button>
      </div>
    </div>
  }
  <div>
    @if (!largeView) {
      <!-- Tabs Navigation for mobile view-->
      <ul class="nav nav-tabs mb-2" id="checkpointsTab" role="tablist">
        <li class="nav-item" role="presentation">
          <a
            class="nav-link active"
            id="all-checkpoints-tab"
            data-bs-toggle="tab"
            href="#all-checkpoints"
            role="tab"
            aria-controls="all-checkpoints"
            aria-selected="true"
            >Checkpoints</a
          >
        </li>
        <li class="nav-item" role="presentation">
          <a
            class="nav-link"
            id="selected-checkpoints-tab"
            data-bs-toggle="tab"
            href="#selected-checkpoints"
            role="tab"
            aria-controls="selected-checkpoints"
            aria-selected="false"
            >Added
            <span class="ms-1">[{{ selectedCheckpoints?.length }}]</span>
          </a>
        </li>
      </ul>
      <!-- Tabs Content -->
      <div class="tab-content" id="checkpointsTabContent">
        <!-- All Checkpoints Tab -->
        <div
          class="tab-pane fade show active"
          id="all-checkpoints"
          role="tabpanel"
          aria-labelledby="all-checkpoints-tab"
        >
          <ng-template
            *ngTemplateOutlet="
              checkPointSearchSelectTemplate;
              context: { value: { search: true } }
            "
          ></ng-template>
        </div>
        <!-- Selected Checkpoints Tab -->
        <div
          class="tab-pane fade"
          id="selected-checkpoints"
          role="tabpanel"
          aria-labelledby="selected-checkpoints-tab"
        >
          <ng-template
            *ngTemplateOutlet="checkPointSearchSelectTemplate; context: {}"
          ></ng-template>
        </div>
      </div>
    }
    @if (largeView) {
      <div class="row row-cols-2 mb-1">
        <div class="col">
          <dt class="p-3 pt-0">Checkpoints</dt>
          <ng-template
            *ngTemplateOutlet="
              checkPointSearchSelectTemplate;
              context: { value: { search: true } }
            "
          ></ng-template>
        </div>
        <div class="col">
          <dt class="p-3 pt-0">Added</dt>
          <ng-template
            *ngTemplateOutlet="checkPointSearchSelectTemplate; context: {}"
          ></ng-template>
        </div>
      </div>
    }
  </div>
  @if (showUpdateFutureShifts) {
    <div
      class="col col-6 offset-6 my-3 gap-2 d-flex align-items-center justify-content-center fw-semibold"
    >
      <input
        class="form-check-input"
        type="checkbox"
        id="auto_send_reports"
        [checked]="!updateFutureShifts"
        (change)="updateFutureShifts = !updateFutureShifts"
      />
      <label class="form-check-label" for="auto_send_reports">
        Apply only to this shift</label
      >
    </div>
  }

  <div class="row row-cols-2">
    <div class="col">
      <button class="btn btn-lg btn-secondary w-100" (click)="onDialogClose()">
        Cancel
      </button>
    </div>

    <div class="col">
      <button
        type="submit"
        class="btn btn-lg btn-primary w-100"
        (click)="onDialogClose(true)"
      >
        Save
      </button>
    </div>
  </div>
</div>

<ng-template let-dataItem="value" #checkPointSearchSelectTemplate>
  @if (dataItem?.search) {
    @if (patrolRouteCpTotalCount > 10) {
      <div class="input-group my-2">
        <div class="form-floating">
          <input
            class="form-control"
            type="text"
            placeholder="Search Filter"
            (input)="searchCheckPoints($event)"
            [(ngModel)]="patrolCpFilterValue"
          />
          <label>Search Filter</label>
        </div>

        @if (patrolCpFilterValue) {
          <span
            class="input-group-text"
            (click)="searchCheckPoints({ target: { value: '' } })"
          >
            <i class="fa-solid fa-xmark"></i>
          </span>
        }
      </div>
    }

    @if (patrolRouteCPList?.length) {
      @if (!patrolCPCursor && patrolRouteCPList?.length > 1) {
        <div class="text-end my-2">
          <button
            (click)="addAllCheckpoints()"
            class="btn btn-warning btn-sm"
            [disabled]="selectedCheckpoints?.length >= 250"
          >
            Add All
            <span class="fs-6 fw-semibold px-2">{{
              patrolRouteCPList?.length
            }}</span>
          </button>
        </div>
      }
      <div
        class="mb-2"
        [ngClass]="
          patrolRouteCpTotalCount > 10
            ? 'checkpoints-list-with-search'
            : 'checkpoints-list-without-search'
        "
      >
        @for (checkpoint of patrolRouteCPList; track $index) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2">
            <div
              class="flex-grow-1"
              [class.added-checkpoint]="
                checkpoint?.id === lastAddedCheckpointID
              "
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div>
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }

            <div (click)="addSelectedCP(checkpoint)">
              <button
                class="btn btn-primary btn-sm m-0"
                [disabled]="selectedCheckpoints?.length >= 250"
              >
                Add
              </button>
            </div>
          </div>
        }
      </div>
      @if (patrolCPCursor) {
        <div class="text-center my-2">
          <button (click)="onLoadMore()" class="btn btn-secondary btn-md px-4">
            Load More
          </button>
        </div>
      }
    } @else if (cpSiteFilter?.id || patrolCpFilterValue) {
      <div class="alert alert-primary fw-bold">
        No Records Match Your Search Criteria
      </div>
    }
  } @else {
    @if (selectedCheckpoints?.length) {
      <div
        class="d-flex justify-content-between m-1 p-1 ps-2 border rounded align-items-center"
      >
        <div class="fs-5">
          <span class="text-secondary"> Checkpoints:</span>
          <span class="fw-semibold"> {{ selectedCheckpoints?.length }}</span>
        </div>
        <div>
          @if (selectedCheckpoints?.length > 1) {
            <button
              (click)="selectedCheckpoints = []"
              class="btn btn-danger btn-sm"
              type="button"
            >
              Remove All
            </button>
          }
        </div>
      </div>
    }

    <div class="checkpoints-list-without-search">
      <div cdkDropList (cdkDropListDropped)="dropNewCheckPoint($event)">
        @for (
          checkpoint of selectedCheckpoints;
          track $index;
          let isLastItem = $last
        ) {
          <div class="d-flex align-items-center p-1 p-lg-2 mb-2 gap-2" cdkDrag>
            @if (selectedCheckpoints?.length > 1) {
              <div cdkDragHandle>
                <i class="fas fa-bars fa-2x"></i>
              </div>
            }

            <div
              class="flex-grow-1"
              [class.added-checkpoint]="
                checkpoint?.id === lastAddedCheckpointID && isLastItem
              "
            >
              <div class="fw-semibold">
                {{ checkpoint?.name }}
              </div>

              <div class="small-font fw-semibold">
                @if (checkpoint?.site_name) {
                  {{ checkpoint?.site_name }} [{{
                    checkpoint?.company || checkpoint?.company_name
                  }}]
                } @else {
                  {{ checkpoint?.company || checkpoint?.company_name }}
                }
              </div>

              <div class="small-font text-secondary">
                {{
                  checkpoint?.address?.full_address || checkpoint?.full_address
                }}
              </div>
            </div>
            @if (checkpoint?.qr_code) {
              <div class="me-2">
                @if (checkpoint?.is_nfc_code) {
                  <img
                    src="assets/images/NFC_logo.avif"
                    alt="NFC Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                } @else {
                  <img
                    src="assets/images/qr-code-logo.avif"
                    alt="QR Code"
                    width="26"
                    class="mb-0 bg-white p-1 rounded"
                  />
                }
              </div>
            }
            <div (click)="removeSelectedCP($index)">
              <button class="btn btn-danger btn-sm m-0">Del</button>
            </div>
          </div>
        }
      </div>
      <div id="lastElementAnchor">
        <!--scroll to here/bottom anchor on adding checkpoints-->
      </div>
    </div>
  }
</ng-template>
